import React, { useState, useEffect } from "react";
import "../../style/Liste.css";
import { Link } from "react-router-dom";
import axios from "axios";

import AdminAjoutFournisseur from "./AdminAjoutFournisseur";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";

const API_URL = process.env.REACT_APP_API_URL;

function AdminListeFournisseursLentilles() {
  const [fournisseursLentilles, setFournisseursLentilles] = useState([]);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    function getFournisseursLentilles() {
      axios
        .get(`${API_URL}/api/lentilles`)
        .then((res) => res.data)
        .then((data) => {
          setFournisseursLentilles(data);
        });
    }
    getFournisseursLentilles();
  }, []);

  return (
    <div className="listeMain">
      <h1>Liste des fournisseurs lentilles</h1>
      <MDBBtn type="button" outline color="primary" onClick={handleShow}>
        Ajouter un fournisseur
      </MDBBtn>
      <div>
        {fournisseursLentilles ? (
          fournisseursLentilles.map((fournisseurLentilles) => {
            return (
              <Link
                to={`/admin-fournisseurs-lentilles/${fournisseurLentilles.id}`}
              >
                <img
                  src={`${API_URL}/images/fournisseurs-lentilles/${fournisseurLentilles.id}.png`}
                  alt={fournisseurLentilles.nom}
                  className="listeLogo"
                />
              </Link>
            );
          })
        ) : (
          <li>Loading</li>
        )}
      </div>
      <MDBContainer>
        <MDBModal isOpen={show} toggle={handleClose}>
          <MDBModalHeader>Créer un fournisseur </MDBModalHeader>
          <MDBModalBody>
            <AdminAjoutFournisseur category="lentilles" />
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn type="button" outline color="primary" onClick={handleClose}>
              Fermer
            </MDBBtn>
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default AdminListeFournisseursLentilles;
